import type { ComponentProps } from 'react';

import { QuantitySelector } from './QuantitySelector';

import { Control, Controller, Path } from 'react-hook-form';

interface QuantityInputControlledProps<T>
    extends Omit<
        ComponentProps<typeof QuantitySelector>,
        'defaultQty' | 'qtyChanged'
    > {
    control: Control<T>;
    name: Path<T>;
}

const QuantityInputControlled = <T,>({
    control,
    name,
    ...props
}: QuantityInputControlledProps<T>) => {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { value, onChange } }) => (
                <QuantitySelector
                    {...props}
                    defaultQty={Number(value)}
                    qtyChanged={(quantity): void => onChange(Number(quantity))}
                />
            )}
        />
    );
};

export default QuantityInputControlled;
